import { RefAnneeType } from './ref-annee-type.model';
import { RefModeCalcul } from './ref-mode-calcul.model';
import { RefTva } from './ref-tva.model';
import { RefObjetFacture } from './ref-objet-facture.model';
import { RefQuantiteFacture } from './ref-quantite-facture.model';
import { ArrayClassConverterFactory } from '../../../core/services/mapper/data-property.converter';

export class ReferencesFacturation {
    static jsonMap = {
        refAnneeTypeList: { key: 'refAnneeTypeList', converter: new (ArrayClassConverterFactory.build(RefAnneeType))() },
        refModeCalculList: { key: 'refModeCalculList', converter: new (ArrayClassConverterFactory.build(RefModeCalcul))() },
        refObjetFactureList: { key: 'refObjetFactureList', converter: new (ArrayClassConverterFactory.build(RefObjetFacture))(), optional: true },
        refTvaList: { key: 'refTvaList', converter: new (ArrayClassConverterFactory.build(RefTva))() },
        refQuantiteFactureList: { key: 'refQuantiteFactureList', converter: new (ArrayClassConverterFactory.build(RefQuantiteFacture))(), optional: true }
    };

    refAnneeTypeList: RefAnneeType[];
    refModeCalculList: RefModeCalcul[];
    refObjetFactureList: RefObjetFacture[];
    refTvaList: RefTva[];
    refQuantiteFactureList: RefQuantiteFacture[];
}
